



























































































































































































































































































































































































































































































































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { EnterpriseInfo } from "../../_models/enterpriseInfo";
import { userUtils } from "../../_utils/userUtils";
import { bus } from "../../main";
import * as user from "../../_store/user.module";
import * as auth from "../../_store/auth.module";
import * as data from "../../_store/data.module";
import { RichiestaTirFormativi } from "../../_models/richiestaTirFormativi"
import { router } from "../../_router";
import * as temp from "../../_store/temp.module"

@Component
export default class RichiestaTirocinantiFormativiCreate extends Vue {
  @Prop() params!: any;
  @Prop() enterpriseInfo!: EnterpriseInfo;
  @Prop() idIscrizioneAttivita!: number;

  private comuni: any;
  private searchComuni: object | null;
  private isLoadingComuni: boolean;

  // private indirizziStudio: [{
  //   idIndirizzo: number;
  //   nomeIndirizzo: string;
  // }];

  private indirizziStudio: any;
  // private searchIndirizziStudio: object | null;
  // private idLoadingIndirizziStudio: boolean;

  private ruolo: string;
  private titolo: string;
  private cognomeRappresentanteAzienda: string;
  private nomeRappresentanteAzienda: string;
  private statoNascitaRappresentanteAzienda: string;
  private luogoNascitaRappresentante: string;
  private dataNascitaRappresentante: string;
  private denominazioneAzienda: string;
  private provinciaAzienda: string;
  private comuneAzienda: string;
  private cap: string;
  private indirizzoAzienda: string;
  private telefono1Azienda: string;
  private faxAzienda: string;
  private pIva: string;
  private emailAzienda: string;
  private sitoAzienda: string;
  private lavoratoriSede: string;
  private tirociniSede: string;
  private tirociniDisabiliSede: string;
  private attivitàAzienda: string;
  private dipendentiAzienda: string;
  private associata: boolean;
  private artigiana: boolean;
  private descrizioneAteco: string;
  private descrizioneIstat: string;
  private consulente: string;

  private provinciaTirocinio: string;
  private comuneTirocinio: string;
  private capTirocinio: string;
  private indirizzoTirocinio: string;
  private consulenteOptions: string[];
  private denominazioneConsulente: string;
  private referenteConsulente: string;
  private telefonoConsulente: string;
  private emailConsulente: string;
  private attivitàTirocinio: string;
  private indirizzoStudio: string;
  private numeroTirocinanti: number;
  private nTirocinantiDisabili: number;

  private cognomeTirocinante: string;
  private nomeTirocinante: string;
  private classeTirocinante: string;
  private usoFuoriSede: string;
  private autorizzazioneTrattamentoDati: string;

  private sedeRadioGroup: string;
  private conoscenzaNormativa: string;
  // private indirizziStudio: string[];

  private idCPIstat: number;
  private istatList: any;
  private isLoadingIstat: boolean;
  private searchIstat: object | null;

  private classiList: any;

  private ruoloRules: [boolean | string];
  private titoloRules: [boolean | string];
  private cognomeRappresentanteRules: [boolean | string];
  private nomeRappresentanteRules: [boolean | string];
  private statoNascitaRappresentanteRules: [boolean | string];
  private luogoNascitaRappresentanteRules: [boolean | string];
  private dataNascitaRappresentanteRules: [boolean | string];
  private denominazioneAziendaRules: [boolean | string];
  private provinciaAziendaRules: [boolean | string];
  private comuneAziendaRules: [boolean | string];
  private capRules: [boolean | string];
  private indirizzoAziendaRules: [boolean | string];
  private telRules: [boolean | string];
  private faxAziendaRules: [boolean | string];
  private pIvaRules: [boolean | string];
  private emailAziendaRules: [boolean | string];
  private sitoAziendaRules: [boolean | string];
  private lavoratoriSedeRules: [boolean | string];
  private tirociniSedeRules: [boolean | string];
  private tirociniDisabiliSedeRules: [boolean | string];
  private attivitàRules: [boolean | string];
  private dipendentiAziendaRules: [boolean | string];
  private descrizioneAtecoRules: [boolean | string];
  private descrizioneIstatRules: [boolean | string];

  private cognomeTirocinanteRules: [boolean | string];
  private nomeTirocinanteRules: [boolean | string];
  private classeTirocinanteRules: [boolean | string];

  private provinciaTirocinioRules: [boolean | string];
  private comuneTirocinioRules: [boolean | string];
  private capTirocinioRules: [boolean | string];
  private indirizzoTirocinioRules: [boolean | string];
  private consulenteRules: [boolean | string];
  private denominazioneConsulenteRules: [boolean | string];
  private referenteConsulenteRules: [boolean | string];
  private telefonoConsulenteRules: [boolean | string];
  private emailConsulenteRules: [boolean | string];
  private attivitàTirocinioRules: [boolean | string];
  private indirizzoStudioRules: [boolean | string];
  private numeroTirocinantiRules: [boolean | string];
  private nTirocinantiDisabiliRules: [boolean | string];

  private istatRules: [boolean | string];

  // private roles: string[];

  constructor() {
    super();

    this.comuni = [];
    this.searchComuni = null;
    this.isLoadingComuni = false;

    this.idCPIstat = 0;
    this.istatList = [];
    this.searchIstat = null;
    this.isLoadingIstat = false;

    //   private idCPIstat: number;
    // private istatList: any;
    // private isLoadingIstat: boolean;
    // private searchIstat: object | null;

    this.ruolo = "LEGALE RAPPRESENTANTE";
    this.titolo = this.enterpriseInfo.titolo;
    this.cognomeRappresentanteAzienda = this.enterpriseInfo.cognomeRappresentanteAzienda;
    this.nomeRappresentanteAzienda = this.enterpriseInfo.nomeRappresentanteAzienda;
    this.statoNascitaRappresentanteAzienda = this.enterpriseInfo.statoNascitaRappresentante;
    this.luogoNascitaRappresentante = this.enterpriseInfo.luogoNascitaRappresentante;
    this.dataNascitaRappresentante = this.enterpriseInfo.dataNascitaRappresentante;
    this.denominazioneAzienda = this.enterpriseInfo.denominazioneAzienda;
    this.provinciaAzienda = this.enterpriseInfo.provinciaAzienda;
    this.comuneAzienda = this.enterpriseInfo.comuneAzienda;
    this.cap = this.enterpriseInfo.cap;
    this.indirizzoAzienda = this.enterpriseInfo.indirizzoAzienda;
    this.telefono1Azienda = this.enterpriseInfo.telefono1Azienda;
    this.faxAzienda = this.enterpriseInfo.faxAzienda;
    this.pIva = this.enterpriseInfo.pIva;
    this.emailAzienda = this.enterpriseInfo.emailAzienda;
    this.sitoAzienda = this.enterpriseInfo.sitoAzienda;
    this.lavoratoriSede = "";
    this.tirociniSede = "";
    this.tirociniDisabiliSede = "";
    this.attivitàAzienda = this.enterpriseInfo.attivitàAzienda;
    this.dipendentiAzienda = this.enterpriseInfo.dipendentiAzienda;
    this.associata = this.enterpriseInfo.associata;
    this.artigiana = this.enterpriseInfo.artigiana;
    this.descrizioneAteco = this.enterpriseInfo.descrizioneAteco;
    this.descrizioneIstat = this.enterpriseInfo.descrizioneIstat;
    this.consulente = "";

    this.conoscenzaNormativa = "false";

    this.cognomeTirocinante = "";
    this.nomeTirocinante = "";
    this.classeTirocinante = "";
    this.usoFuoriSede = "false";
    this.autorizzazioneTrattamentoDati = "false";

    this.provinciaTirocinio = "";
    this.comuneTirocinio = "";
    this.capTirocinio = "";
    this.indirizzoTirocinio = "";
    this.consulenteOptions = ["ESTERNO", "INTERNO"];
    this.denominazioneConsulente = "";
    this.referenteConsulente = "";
    this.telefonoConsulente = "";
    this.emailConsulente = "";
    this.attivitàTirocinio = "";
    this.indirizzoStudio = "";
    this.numeroTirocinanti = 1;
    this.nTirocinantiDisabili = 0;

    this.sedeRadioGroup = "false";
    // this.indirizziStudio = [
    //   "TECNOLOGICO INDIRIZZO ELETTROTECNICO",
    //   "TECNOLOGICO INDIRIZZO INFORMATICO",
    //   "TECNOLOGICO INDIRIZZO MECCANICO",
    //   "LICEO SCIENTIFICO SCIENZE APPLICATE",
    //   "ECONOMICO INDIRIZZO AMMINISTR. FINANZE E MARKETING",
    //   "ECONOMICO INDIRIZZO TURISTICO"
    // ];

    this.indirizziStudio = [];
    this.classiList = [];
    // this.searchIndirizziStudio = null;
    // this.idLoadingIndirizziStudio = false;

    this.ruoloRules = [true];
    this.titoloRules = [true];
    this.cognomeRappresentanteRules = [true];
    this.nomeRappresentanteRules = [true];
    this.statoNascitaRappresentanteRules = [true];
    this.luogoNascitaRappresentanteRules = [true];
    this.dataNascitaRappresentanteRules = [true];
    this.denominazioneAziendaRules = [true];
    this.provinciaAziendaRules = [true];
    this.comuneAziendaRules = [true];
    this.capRules = [true];
    this.indirizzoAziendaRules = [true];
    this.telRules = [true];
    this.faxAziendaRules = [true];
    this.pIvaRules = [true];
    this.emailAziendaRules = [true];
    this.sitoAziendaRules = [true];
    this.lavoratoriSedeRules = [true];
    this.tirociniSedeRules = [true];
    this.tirociniDisabiliSedeRules = [true];
    this.attivitàRules = [true];
    this.dipendentiAziendaRules = [true];
    this.descrizioneAtecoRules = [true];
    this.descrizioneIstatRules = [true];

    this.cognomeTirocinanteRules = [true];
    this.nomeTirocinanteRules = [true];
    this.classeTirocinanteRules = [true];

    this.provinciaTirocinioRules = [true];
    this.comuneTirocinioRules = [true];
    this.capTirocinioRules = [true];
    this.indirizzoTirocinioRules = [true];
    this.consulenteRules = [true];
    this.denominazioneConsulenteRules = [true];
    this.referenteConsulenteRules = [true];
    this.telefonoConsulenteRules = [true];
    this.emailConsulenteRules = [true];
    this.attivitàTirocinioRules = [true];
    this.indirizzoStudioRules = [true];
    this.numeroTirocinantiRules = [true];
    this.nTirocinantiDisabiliRules = [true]

    this.istatRules = [true];
  }

  get IsChecked() {
    return (
      this.conoscenzaNormativa === "true" &&
      this.autorizzazioneTrattamentoDati === "true"
    );
  }

  @Watch("provinciaTirocinio")
  onProvinciaTirocinioChange(value: string) {
    this.provinciaTirocinio = value.toUpperCase();
  }
  @Watch("referenteConsulente")
  onReferenteConsulenteChange(value: string) {
    this.referenteConsulente = value.toUpperCase();
  }

  @Watch("searchComuni")
  onComuniChanged(value: string) {
    if (this.comuni.length > 0) return;
    this.isLoadingComuni = true;
    data
      .dispatchComuniList(this["$store"])
      .then(response => {
        if (response !== null) {
          this.comuni = response;
        }
      })
      .catch(error => {
        bus.$emit(
          "errorOperation",
          "Errore nel caricamento della lista comuni"
        );
      })
      .finally(() => (this.isLoadingComuni = false));
  }

  @Watch("searchIstat")
  onIstatChange(value: string) {
    if (this.istatList.length > 0) return;
    this.isLoadingIstat = true;
    data
      .dispatchIstatList(this["$store"])
      .then(response => {
        if (response !== null) {
          this.istatList = response;
        }
      })
      .catch(error => {
        bus.$emit(
          "errorOperation",
          "Errore nel caricamento della lista codici CP ISTAT"
        );
      })
      .finally(() => (this.isLoadingIstat = false));
  }

  // @Watch("searchIndirizziStudio")
  // onIndirizziStudioChanged(value: string) {
  //   if (this.indirizziStudio.length > 0) return;
  //   this.idLoadingIndirizziStudio = true;
  //   data
  //     .dispatchListaIndirizziStudi(this["$store"], this.params.idIstituto)
  //     .then(response => {
  //       if (response !== null) {
  //         this.indirizziStudio = response;
  //       }
  //     })
  //     .catch(error => {
  //       bus.$emit(
  //         "errorOperation",
  //         "Errore nel caricamento della lista indirizzi studio"
  //       );
  //     })
  //     .finally(() => (this.isLoadingComuni = false));
  // }

  validazioneFax() {
    var valid: boolean = false;
    if (this.faxAzienda === "" || this.faxAzienda === null) {
      this.faxAziendaRules = [true];
    } else {
      valid = /[0-9]{8,15}$/.test(this.faxAzienda);
      if (valid) {
        this.faxAziendaRules = [true];
      } else {
        this.faxAziendaRules = [
          "Il numero di telefono non ha un formato corretto"
        ];
      }
    }
  }

  validazioneIstat() {
    if (this.idCPIstat === 0) {
      this.istatRules = ["Codice CP Istat necessario"];
    } else {
      this.istatRules = [true];
    }
  }

  validazioneLavoratoriSede() {
    if (this.lavoratoriSede === "" || this.lavoratoriSede === null) {
      this.lavoratoriSedeRules = ["Numero lavoratori necessario"];
    } else {
      this.lavoratoriSedeRules = [true];
    }
  }

  validazioneTirociniSede() {
    if (this.tirociniSede === "" || this.tirociniSede === null) {
      this.tirociniSedeRules = ["Numero tirocini in corso necessario"];
    } else {
      this.tirociniSedeRules = [true];
    }
  }

  validazioneTirociniDisabiliSede() {
    if (
      this.tirociniDisabiliSede === "" ||
      this.tirociniDisabiliSede === null
    ) {
      this.tirociniDisabiliSedeRules = ["Numero tirocini in corso necessario"];
    } else {
      this.tirociniDisabiliSedeRules = [true];
    }
  }

  validazioneComuneTirocinio() {
    if (this.sedeRadioGroup === "true") {
      if (this.comuneTirocinio === "" || this.comuneTirocinio === null) {
        this.comuneTirocinioRules = ["Comune tirocinio necessario"];
      } else {
        this.comuneTirocinioRules = [true];
      }
    }
  }

  validazioneProvinciaTirocinio() {
    var valid: boolean = false;
    if (this.sedeRadioGroup === "true") {
      if (this.provinciaTirocinio === "" || this.provinciaTirocinio === null) {
        this.provinciaTirocinioRules = ["Provincia tirocinio necessaria"];
      } else {
        valid = /^[A-Z]{2}$/.test(this.provinciaTirocinio);
        if (valid) {
          this.provinciaTirocinioRules = [true];
        } else {
          this.provinciaTirocinioRules = [
            "La provincia non ha un formato corretto"
          ];
        }
      }
    }
  }

  validazioneCapTirocinio() {
    var valid: boolean = false;
    if (this.sedeRadioGroup === "true") {
      if (this.capTirocinio === "" || this.capTirocinio === null) {
        this.capTirocinioRules = ["Cap tirocinio necessario"];
      } else {
        valid = /^[0-9]{5}$/.test(this.capTirocinio);
        if (valid) {
          this.capTirocinioRules = [true];
        } else {
          this.capTirocinioRules = ["Il Cap non ha un formato corretto"];
        }
      }
    }
  }

  validazioneConsulente() {
    if (this.consulente === "" || this.consulente === null) {
      this.consulenteRules = ["Indicazione consulente necessaria"];
    } else {
      this.consulenteRules = [true];
    }
  }

  validazioneIndirizzoTirocinio() {
    var valid: boolean = false;
    if (this.sedeRadioGroup === "true") {
      if (this.indirizzoTirocinio === "" || this.indirizzoTirocinio === null) {
        this.indirizzoTirocinioRules = ["Indirizzo tirocinio necessario"];
      } else {
        valid = /^[a-zA-Z00-9ìèéùòà,'\x20/-]{2,100}$/.test(
          this.indirizzoTirocinio
        );
        if (valid) {
          this.indirizzoTirocinioRules = [true];
        } else {
          this.indirizzoTirocinioRules = [
            "L'Indirizzo non ha un formato corretto"
          ];
        }
      }
    }
  }

  validazioneDenominazioneConsulente() {
    var valid: boolean = false;
    if (
      this.denominazioneConsulente === "" ||
      this.denominazioneConsulente === null
    ) {
      this.denominazioneConsulenteRules = ["Denominazione necessaria"];
    } else {
      valid = /^[a-zA-Z0-9ìèéùòà'&.\x20/-]{2,100}$/.test(
        this.denominazioneConsulente
      );
      if (valid) {
        this.denominazioneConsulenteRules = [true];
      } else {
        this.denominazioneConsulenteRules = [
          "La denominazione deve essere minore di 100 caratteri"
        ];
      }
    }
  }

  validazioneReferente() {
    var valid: boolean = false;
    if (this.referenteConsulente === "" || this.referenteConsulente === null) {
      this.referenteConsulenteRules = ["Denominazione necessaria"];
    } else {
      valid = /^[a-zA-Zìèéùòà'\x20]{2,100}$/.test(this.referenteConsulente);
      if (valid) {
        this.referenteConsulenteRules = [true];
      } else {
        this.referenteConsulenteRules = [
          "Il referente deve essere minore di 100 caratteri e non deve contenere numeri"
        ];
      }
    }
  }

  validazioneTelefonoConsulente() {
    var valid: boolean = false;
    if (this.telefonoConsulente === "" || this.telefonoConsulente === null) {
      this.telefonoConsulenteRules = ["Telefono necessario"];
    } else {
      valid = /[0-9]{8,15}$/.test(this.telefonoConsulente);
      if (valid) {
        this.telefonoConsulenteRules = [true];
      } else {
        this.telefonoConsulenteRules = [
          "Il numero di telefono non ha un formato corretto"
        ];
      }
    }
  }

  validazioneEmailConsulente() {
    var valid: boolean = false;
    if (this.emailConsulente === "" || this.emailConsulente === null) {
      this.emailConsulenteRules = ["Email necessaria"];
    } else {
      valid = /[a-zA-Z0-9._&-]+@[a-zA-Z0-9._&-]+\.[a-z]{2,}$/.test(
        this.emailConsulente
      );
      if (valid) {
        this.emailConsulenteRules = [true];
      } else {
        this.emailConsulenteRules = ["L'email non ha un formato corretto"];
      }
    }
  }

  validazioneAttivitaTirocinio() {
    var valid: boolean = false;
    if (this.attivitàTirocinio === "" || this.attivitàTirocinio === null) {
      this.attivitàTirocinioRules = ["Obiettivi del tirocinio necessari"];
    } else {
      valid = /^[0-9a-zA-Zìèéùòà',.\x20]{2,250}$/.test(this.attivitàTirocinio);
      if (valid) {
        this.attivitàTirocinioRules = [true];
      } else {
        this.attivitàTirocinioRules = [
          "Obiettivi tirocinio non può avere più di 250 caratteri e non deve contenere caratteri speciali"
        ];
      }
    }
  }

  validazioneIndirizzoStudio() {
    if (this.indirizzoStudio === "" || this.indirizzoStudio === null) {
      this.indirizzoStudioRules = ["Settore formativo necessario"];
    } else {
      this.indirizzoStudioRules = [true];
    }
  }

  validazioneNumeroTirocinanti() {
    if (this.numeroTirocinanti === 0 || this.numeroTirocinanti === null) {
      this.numeroTirocinantiRules = ["Numero tirocinanti necessario"];
    } else {
      if (this.numeroTirocinanti > 0) {
        this.numeroTirocinantiRules = [true];
      } else {
        this.numeroTirocinantiRules = [
          "Il numero di tirocinanti deve essere maggiore di zero"
        ];
      }
    }
  }
  // validazioneCognomeTirocinante() {
  //   console.log("eseguo")
  //   var valid1: boolean;
  //   valid1 = /^[a-zA-Zìèéùòà'\x20]{2,50}$/.test(this.cognomeTirocinante);
  //   if (valid1) {
  //     this.cognomeTirocinanteRules = [true];
  //   } else {
  //     this.cognomeTirocinanteRules = [
  //       "Cognome non può essere più lungo di 50 caratteri e non può contenere numeri"
  //     ];
  //   }
  // }

  validazioneEventualeTirocinante() {
    // if((this.cognomeTirocinante !== "" && this.nomeTirocinante !== "") && this.classeTirocinante !== ""){

    // }else{
    var valid1: boolean = false;
    var valid2: boolean = false;
    var valid3: boolean = false;
    if (
      this.cognomeTirocinante !== "" ||
      this.nomeTirocinante !== "" ||
      this.classeTirocinante !== ""
    ) {
      if (this.cognomeTirocinante !== "") {
        // this.validazioneCognomeTirocinante()
        valid1 = /^[a-zA-Zìèéùòà'\x20]{2,50}$/.test(this.cognomeTirocinante);
        if (valid1) {
          this.cognomeTirocinanteRules = [true];
        } else {
          this.cognomeTirocinanteRules = [
            "Cognome non può essere più lungo di 50 caratteri e non può contenere numeri"
          ];
        }
      } else {
        this.cognomeTirocinanteRules = ["Cognome tirocinante necessario"];
      }
      if (this.nomeTirocinante !== "") {
        valid1 = /^[a-zA-Zìèéùòà'\x20]{2,50}$/.test(this.nomeTirocinante);
        if (valid1) {
          this.nomeTirocinanteRules = [true];
        } else {
          this.nomeTirocinanteRules = [
            "Nome non può essere più lungo di 50 caratteri e non può contenere numeri"
          ];
        }
      } else {
        this.nomeTirocinanteRules = ["Nome tirocinante necessario"];
      }
      if (this.classeTirocinante !== "") {
        valid1 = /^[a-zA-Z0-9\x20]{1,3}$/.test(this.classeTirocinante);
        if (valid1) {
        this.classeTirocinanteRules = [true];
        } else {
          this.classeTirocinanteRules = [
            "Classe  non può essere più lungo di 3 caratteri"
          ];
        }
      // } else {
      //   this.classeTirocinanteRules = ["Classe tirocinante necessaria"];
      // }
    }
    }
  }

  async executeTest() {
    this.validazioneFax();
    this.validazioneLavoratoriSede();
    this.validazioneTirociniSede(); 
    this.validazioneTirociniDisabiliSede();
    this.validazioneComuneTirocinio();
    this.validazioneProvinciaTirocinio();
    this.validazioneCapTirocinio();
    this.validazioneConsulente();
    this.validazioneIndirizzoTirocinio();
    this.validazioneDenominazioneConsulente();
    this.validazioneReferente();
    this.validazioneTelefonoConsulente();
    this.validazioneEmailConsulente();
    this.validazioneAttivitaTirocinio();
    this.validazioneIndirizzoStudio();
    this.validazioneNumeroTirocinanti();
    this.validazioneEventualeTirocinante();
    this.validazioneIstat();
  }

  save() {
    var richiestaTirFormativo: RichiestaTirFormativi;
    var i: number;
    var sendError: boolean;
    var comuneT: string;
    var provinciaT: string;
    var capT: string;
    var indirizzoT: string;
    var cognomeT: string | null;
    var nomeT: string | null;
    var classeT: string | null;
    var utilizzoFuoriSede: boolean;
    this.executeTest().then(() => {
      if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
        if (this.IsChecked) {
          cognomeT = this.cognomeTirocinante;
          nomeT = this.nomeTirocinante;
          classeT = this.classeTirocinante;
          sendError = false;
          if (cognomeT === "") {
            cognomeT = null;
            nomeT = null;
            classeT = null;
          }
          // if(this.tirociniDisabiliSede === ""){
          //   this.tirociniDisabiliSede = "0"
          // }
          i = 0;
          while (i < this.numeroTirocinanti && sendError === false) {
            // for (i = 0; i < this.numeroTirocinanti; i++) {
            if (this.sedeRadioGroup === "true") {
              comuneT = this.comuneTirocinio;
              provinciaT = this.provinciaTirocinio;
              capT = this.capTirocinio;
              indirizzoT = this.indirizzoTirocinio;
            } else {
              comuneT = this.comuneAzienda;
              provinciaT = this.provinciaAzienda;
              capT = this.cap;
              indirizzoT = this.indirizzoAzienda;
            }
            if (this.usoFuoriSede === "false") {
              utilizzoFuoriSede = false;
            } else {
              utilizzoFuoriSede = true;
            }
            richiestaTirFormativo = {
              idAzienda: this.enterpriseInfo.idAzienda,
              denominazioneAzienda: this.enterpriseInfo.denominazioneAzienda,
              cognomeRappresentanteAzienda: this.enterpriseInfo
                .cognomeRappresentanteAzienda,
              titolo: this.enterpriseInfo.titolo,
              nomeRappresentanteAzienda: this.enterpriseInfo
                .nomeRappresentanteAzienda,
              statoNascitaRappresentante: this.enterpriseInfo
                .statoNascitaRappresentante,
              dataNascitaRappresentante: this.enterpriseInfo
                .dataNascitaRappresentante,
              luogoNascitaRappresentante: this.enterpriseInfo
                .luogoNascitaRappresentante,
              comuneAzienda: this.enterpriseInfo.comuneAzienda,
              idCapComuneAzienda: this.enterpriseInfo.idCapComuneAzienda,
              provinciaAzienda: this.enterpriseInfo.provinciaAzienda,
              indirizzoAzienda: this.enterpriseInfo.indirizzoAzienda,
              telefono1Azienda: this.enterpriseInfo.telefono1Azienda,
              telefono2Azienda: this.enterpriseInfo.telefono2Azienda,
              faxAzienda: this.enterpriseInfo.faxAzienda,
              emailAzienda: this.enterpriseInfo.emailAzienda,
              pecAzienda: this.enterpriseInfo.pecAzienda,
              sitoAzienda: this.enterpriseInfo.sitoAzienda,
              attivitàAzienda: this.enterpriseInfo.attivitàAzienda,
              dipendentiAzienda: this.enterpriseInfo.dipendentiAzienda,
              committenzaAzienda: this.enterpriseInfo.committenzaAzienda,
              associata: this.enterpriseInfo.associata,
              artigiana: this.enterpriseInfo.artigiana,
              pIva: this.enterpriseInfo.pIva,
              codAzienda: this.enterpriseInfo.codAzienda,
              idAteco: this.enterpriseInfo.idAteco,
              // idIstat: this.enterpriseInfo.idIstat,
              descrizioneAteco: this.enterpriseInfo.descrizioneAteco,
              descrizioneIstat: this.enterpriseInfo.descrizioneIstat,
              cap: this.enterpriseInfo.cap,
              idNazioneAzienda: this.enterpriseInfo.idNazioneAzienda,
              nazioneAzienda: this.enterpriseInfo.nazioneAzienda,
              lavoratoriSede: this.lavoratoriSede,
              tirociniSede: this.tirociniSede,
              tirociniDisabiliSede: this.tirociniDisabiliSede,
              consulente: this.consulente,
              provinciaTirocinio: provinciaT,
              comuneTirocinio: comuneT,
              capTirocinio: capT,
              indirizzoTirocinio: indirizzoT,
              denominazioneConsulente: this.denominazioneConsulente,
              referenteConsulente: this.referenteConsulente,
              telefonoConsulente: this.telefonoConsulente,
              emailConsulente: this.emailConsulente,
              attivitàTirocinio: this.attivitàTirocinio,
              indirizzoStudio: this.indirizzoStudio,
              cognomeTirocinante: cognomeT,
              nomeTirocinante: nomeT,
              classeTirocinante: classeT,
              usoFuoriSede: utilizzoFuoriSede,
              ruolo: this.ruolo,
              idAziendaIstitutoAnno: 0,
              nomeIndirizzoStudio: "",
              nomeSettore: "",
              idRichiesta: 0,
              idCPIstat: this.idCPIstat,
              descrizioneCPIstat: "",
              idIscrizioneAttivita: this.idIscrizioneAttivita,
              idStatoUtente: 2,
              codRappresentate: "",
              confCommercio: false,
              altraAssociazione: false
              // idIstituto: this.params.idIstituto,
              // idAnnoScolastico: this.params.idAnnoScolastico
            };
            cognomeT = null;
            nomeT = null;
            classeT = null;
            utilizzoFuoriSede = false;
            user
              .dispatchSubmitRichiestaTirFormativo(
                this["$store"],
                richiestaTirFormativo
              )
              .catch(error => {
                sendError = true;
                // console.log(error.response);
                if (error.response.status === 401) {
                  bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
                  this["$router"].push("/login");
                } else {
                  bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
                }
              });
            i++;
            // }
          }
          if (sendError === false) {
            bus.$emit("successfullOperation", "Richiesta inviata con successo. L'Istituto procederà con l'abbinamento. Riceverete nelle prossime settimane ulteriori istruzioni.");
            this["$router"].push("/iscrizioneTirFormativi");
          }
        } else {
          bus.$emit(
            "errorOperation",
            "Non sono stati forniti tutti i consensi"
          );
        }
      }
    });
  }

  cancel() {
    router.push({
      name: "iscrizioneTirFormativi",
      params: {}
    });
  }

  created() {
    var idAnnoScolastico = temp.readIdAnnoScolastico(this["$store"])
    if (this.params !== undefined && this.params !== null) {
      var indirizzo = {
        idIndirizzo: 0,
        nomeIndirizzo: ""
      };
      var payload = {
        idIstituto: this.params.idIstituto,
        idAnnoScolastico: idAnnoScolastico
      };
      var indirizzi: any[] = [];
      data
        .dispatchListaIndirizziStudi(this["$store"], this.params.idIstituto)
        .then(response => {
          response.forEach(function(element: any) {
            indirizzo = {
              idIndirizzo: element.Id,
              nomeIndirizzo:
                element.NomeSettore + " INDIRIZZO " + element.NomeIndirizzo
            };
            indirizzi.push(indirizzo);
          });
          this.indirizziStudio = indirizzi;
          data
            .dispatchComuniList(this["$store"])
            .then(result => {
              var obj = {
                id: 0,
                località: ""
              };
              result.forEach(element => {
                obj = {
                  id: element.id,
                  località: element.località
                };
                this.comuni.push(obj);
              });
            })
            .catch(error => {
              bus.$emit(
                "errorOperation",
                "Errore nel caricamento della lista comuni"
              );
            });
        })
        .catch(error => {
          bus.$emit(
            "errorOperation",
            "Errore nel caricamento della lista indirizzi studio"
          );
        });
      data
        .dispatchIstatList(this["$store"])
        .then(result => {
          var istat: string = "";
          var objIstat = {
            id: 0,
            descrizione: ""
          };
          result.forEach(element => {
            istat = element.codice.trim() + " " + element.descrizione;
            objIstat = {
              id: element.id,
              descrizione: istat
            };
            this.istatList.push(objIstat);
          });
        })
        .catch(error => {
          bus.$emit(
            "errorOperation",
            "Errore nel caricamento della lista codici ISTAT"
          );
        });
      data
        .dispatchClassiIstitutoAnno(this["$store"], payload)
        .then(resp => {
          this.classiList = resp;
        })
        .catch(error => {
          if (error.response.status === 403) {
            bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
            this["$router"].push("/login");
          } else {
            bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
          }
        });

      // if(this.enterpriseInfo !== null && this.enterpriseInfo !== null){
      //   this.cognomeRappresentanteAzienda= this.enterpriseInfo.cognomeRappresentanteAzienda
      // }
      // console.log(this.params)
      // console.log(this.enterpriseInfo)
      // console.log(this.params.idAnnoScolastico)
      // var token = localStorage.getItem("userToken");
      // var parsedToken: any;
      // if (token !== null) {
      //   parsedToken = userUtils.parseToken(token);
      // }
      // var payload = {
      //   idUtente: parsedToken.IdUtente,
      //   tipoSoggetto: parsedToken.IdTipoSoggetto,
      //   username: parsedToken.Username
      // };
      // user
      //   .dispatchSetUserInfo(this["$store"], payload)
      //   .then(() => {
      //     user
      //       .dispatchSetEnterpriseInfo(this["$store"])
      //       .then(() => {
      //         bus.$emit("loadMenu");
      //         // this.enterpriseInfo = user.readEnterpriseInfo(this["$store"]);
      //       })
      //       .catch(() => {
      //         bus.$emit("stopLoading");
      //         auth.dispatchLogout(this["$store"]);
      //         user.dispatchClearState(this["$store"]);
      //         this["$router"].push("/sessionExpired");
      //       });
      //   })
      //   .catch(() => {
      //     bus.$emit("stopLoading");
      //     auth.dispatchLogout(this["$store"]);
      //     user.dispatchClearState(this["$store"]);
      //     this["$router"].push("/sessionExpired");
      //   });
    } else {
      this["$router"].push("/iscrizioneTirFormativi");
    }
  }
}
